export interface AppConfig {
  APP_NAME: string;
  APP_URL: string;
}

function optionalEnv(key: string, fallback: string): string {
  return (import.meta.env[key] as string | undefined) ?? fallback;
}

export const config: AppConfig = {
  APP_NAME: optionalEnv("VITE_APP_NAME", "The Stellar Group"),
  APP_URL: optionalEnv("VITE_APP_URL", "http://localhost:5173"),
};
